(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('SiteLocationSearch', SiteLocationSearch);

    SiteLocationSearch.$inject = ['$resource'];

    function SiteLocationSearch($resource) {
        var resourceUrl =  'api/_search/site-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
